module.exports = "../../static/fonts/Roboto-Regular.3e5675c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular.woff
// module id = 2219
// module chunks = 0